// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__mY2oD","banner":"styles_banner__9mA4G","link":"styles_link__PZ-3u"};